<template>
  <div class="chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

const chartCanvas = ref(null)

const chartData = {
  labels: [
    'Candidatures reçues',
    'En cours d\'examen',
    'Entretien programmé',
    'Entretien terminé',
    'Acceptées',
    'Refusées'
  ],
  datasets: [{
    data: [245, 89, 34, 28, 15, 164],
    backgroundColor: [
      '#2196f3',
      '#ff9800',
      '#9c27b0',
      '#673ab7',
      '#4caf50',
      '#f44336'
    ],
    borderWidth: 2,
    borderColor: '#fff'
  }]
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        padding: 15,
        font: {
          size: 12
        }
      }
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleColor: '#fff',
      bodyColor: '#fff',
      borderColor: '#fff',
      borderWidth: 1,
      callbacks: {
        label: function(context) {
          const total = context.dataset.data.reduce((a, b) => a + b, 0)
          const percentage = ((context.parsed * 100) / total).toFixed(1)
          return `${context.label}: ${context.parsed} (${percentage}%)`
        }
      }
    }
  },
  cutout: '40%'
}

onMounted(() => {
  const ctx = chartCanvas.value.getContext('2d')
  new ChartJS(ctx, {
    type: 'doughnut',
    data: chartData,
    options: chartOptions
  })
})
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 250px;
  width: 100%;
}
</style>
